import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CommonsService } from 'src/app/services/commons.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { SigninService } from 'src/app/services/signin.service';
import { CONSTANTS } from 'src/app/shared/constants';

@Component({
  standalone: false,
  selector: 'app-multi-login',
  templateUrl: './multi-login.component.html',
  styleUrls: ['./multi-login.component.scss']
})
export class MultiLoginComponent implements OnInit {

  showProgress = false;
  key: string;
  signForm: UntypedFormGroup;
  type = 'password';
  receptionMessage = '';
  data: any;
  code: number;
  param = [];
  checkedTerms: boolean;
  firstCall = true;
  validPassTwo = true;
  constructor(private r: Router, private sign: SigninService, private cs: CommonsService, private rc: ReCaptchaV3Service, private f: UntypedFormBuilder, private se: EntitiesService, private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.cs.firstChargePage('Sign In', 'Inicion de sesion tras pulsar boton generar tu informe', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'content', 'Signin-2');
    this.getKey();
    this.generateForm();
  }

  /**
   * te redirige a la ruta que se pasa por parametro
   * @param url: string
   */
  goToUrl = (url) => {
    if ('signin' === url) {
      sessionStorage.setItem('form', '2');
    }
    this.r.navigateByUrl(url);
  }

  /**
   * Muestra la password al mantenerla pulsada
   * @param num: number
   */
  showPass = (num: number) => {
    if (num === 1) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  /**
     * comprueba que es correcto el filtro propuesto del captcha
     * @param data: any
     * @param step: number
     */
  recaptchaCheck = (data, step) => {
    this.rc.execute(this.key, 'login', (token) => {
      this.successCaptcha(data, token, step);
    }, { useGlobalDomain: true });
  }

  successCaptcha = (data, token, step) => {
    this.receptionMessage = null;
    switch (step) {
      case 1:
        this.sign.loginAkana(data, token).subscribe((d: any) => {
          switch (d.Code) {
            case 300: // primera vez que entra en la app por login
              sessionStorage.setItem('t', d.Token);
              this.getEntities(d.Token, 'Inicio de sesion correcto');
              break;
            case 401: // error al introducir credenciales
              this.showProgress = false;
              this.receptionMessage = d.Message;
              break;
            case 406: // numero de intentos superados
              this.showProgress = false;
              this.receptionMessage = d.Message;
              break;
            case 200: // recupera su informe y te redirige a resumen
              this.sign.globalPosition(d.Token).subscribe((c: any) => {
                sessionStorage.setItem('t', c.Token);
                sessionStorage.setItem('_k', this.cs.encrypt(c));
                this.cs.setKpi(c);
                this.cs.eventsAnalitics('conversion', 'Informe recuperado correctamente', 'signin');
                this.r.navigateByUrl('global-position');
              });
              break;
          }
          setTimeout(() => {
            this.receptionMessage = '';
          }, 3000);
        }, err => {
          this.showProgress = false;
          console.error(err);
        });
        break;
    }
  }

  login = (n: number) => {
    let body = null;
    this.showProgress = true;
    this.receptionMessage = '';
    switch (n) {
      case 1:
        body = {
          Name: this.signForm.get('email').value,
          Value: this.signForm.get('password').value,
        };
        this.recaptchaCheck(body, n);
        break;
    }
  }

  private getEntities = (t, d) => {
    this.se.getTink(t).subscribe(data => window.location.href = data);
  }

  private generateForm = () => {
    this.signForm = this.f.group({
      email: new UntypedFormControl({ value: '', disabled: false }, [Validators.pattern(CONSTANTS.REG_EXP_MAIL), Validators.required]),
      password: new UntypedFormControl({ value: '', disabled: false }, [Validators.required])
    }, {});
    sessionStorage.removeItem('signinSCF');
  }

  /**
   * recupera una clave que se usa para el google captcha
   */
  private getKey = () => {
    if (!sessionStorage.getItem('k_ca')) {
      this.sign.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  private patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }
}
